import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function CargoCraneTable({ data, onEdit }) {
  const columns = [
    {
      title: "Cargo Crane Name",
      dataIndex: "crane_name",
      key: "crane_name",
      align: "center",
    },
    {
      title: "Cargo Crane Maker",
      dataIndex: "crane_maker",
      key: "crane_maker",
      align: "center",
    },
    {
      title: "Cargo Crane Model",
      dataIndex: "crane_model",
      key: "crane_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
